const GOOGLE_API_KEY = 'AIzaSyB0-d5yYWMRBo0EcUCDl8yYoN1GAHnxPvY';

interface TranslateResponse {
  data: {
    translations: Array<{
      translatedText: string;
      detectedSourceLanguage?: string;
    }>;
  };
}

export const translateText = async (inputText: string, targetLang: string) => {
  if (inputText === '') return;
  if (!inputText?.trim()) return;

  try {
    const response = await fetch(
      `https://translation.googleapis.com/language/translate/v2?key=${GOOGLE_API_KEY}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          q: inputText,
          source: 'ko',
          target: targetLang, // 번역할 목표 언어
          model: 'nmt',
          // source: 'en'  // 원본 언어 (생략하면 자동 감지)
        }),
      },
    );

    const data = (await response.json()) as TranslateResponse;
    return data.data.translations[0].translatedText;
  } catch (error) {
    console.error('Translation error:', error);
    alert('번역 중 오류가 발생했습니다.');
  } finally {
  }
};
